<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-link-replace">
      <div class="page-title">
        <h2>广告链接替换系统</h2>
      </div>

      <!-- 第一步：查询URL -->
      <el-card class="step-card">
        <div slot="header" class="card-header">
          <span class="step-title">查询URL所在的表</span>
        </div>
        <el-form :inline="true">
          <el-form-item label="原链接">
            <el-input
              v-model="searchUrl"
              placeholder="https://mcxc.uhbbtkbe.cc?channelCode=YNLXP459"
              clearable
              style="width: 450px">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              :loading="searchLoading"
              @click="searchTables">
              统计链接数量
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>

      <!-- 第二步：显示查询结果并选择表 -->
      <el-card v-if="tableList.length > 0" class="step-card">
        <div slot="header" class="card-header">
          <span class="step-title">选择要更新的表</span>
          <span class="total-count">共找到 {{ totalCount }} 条匹配的链接</span>
        </div>
        <el-table
          :data="tableList"
          @selection-change="handleSelectionChange"
          border
          style="width: 100%;">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="tableDesc" label="广告类型" header-align="center" align="center" width="200"></el-table-column>
          <el-table-column prop="tableName" label="表名" header-align="center" align="center"></el-table-column>
          <el-table-column prop="count" label="数据条数" header-align="center" align="center" width="120"></el-table-column>
        </el-table>
        <div class="selection-info">
          <el-tag type="info" v-if="selectedTables.length === 0">请选择要更新的表</el-tag>
          <el-tag type="success" v-else>已选择 {{ selectedTables.length }} 个表</el-tag>
        </div>
      </el-card>

      <!-- 第三步：输入新URL并执行替换 -->
      <el-card v-if="tableList.length > 0" class="step-card">
        <div slot="header" class="card-header">
          <span class="step-title">输入新链接并执行替换</span>
        </div>
        <el-form label-width="100px">
          <el-form-item label="新链接">
            <el-input
              v-model="newUrl"
              placeholder="https://al5m0xh.uhbbtkbe.cc?channelCode=YNLXP459"
              clearable
              style="width: 450px">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="danger"
              icon="el-icon-refresh"
              :loading="replaceLoading"
              :disabled="selectedTables.length === 0 || !newUrl"
              @click="executeReplace">
              执行替换
            </el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </el-card>
</template>

<script>
export default {
  data () {
    return {
      searchUrl: '',
      newUrl: '',
      tableList: [],
      selectedTables: [],
      totalCount: 0,
      searchLoading: false,
      replaceLoading: false
    }
  },
  methods: {
    // 查询URL所在的表
    searchTables() {
      if (!this.searchUrl) {
        this.$message.warning('请输入原链接')
        return
      }

      this.searchLoading = true
      this.tableList = []
      this.selectedTables = []
      this.newUrl = ''

      this.$http.post('/adclickreport/adclickreport/findUrlInTables', {
        url: this.searchUrl
      }).then(({ data: res }) => {
        this.searchLoading = false
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }

        this.tableList = res.data || []

        if (this.tableList.length === 0) {
          this.$message.info('未找到包含该URL的表')
          this.totalCount = 0
        } else {
          // 计算总条数
          this.totalCount = this.tableList.reduce((sum, item) => sum + item.count, 0)
          this.$message.success(res.msg || `找到 ${this.tableList.length} 个表包含该URL`)
        }
      }).catch(() => {
        this.searchLoading = false
      })
    },

    // 处理表格选择
    handleSelectionChange(selection) {
      this.selectedTables = selection.map(item => item.tableName)
    },

    // 执行替换
    executeReplace() {
      if (!this.searchUrl || !this.newUrl) {
        this.$message.warning('请输入原链接和新链接')
        return
      }

      if (this.selectedTables.length === 0) {
        this.$message.warning('请选择要更新的表')
        return
      }

      const selectedTableDescs = this.tableList
        .filter(t => this.selectedTables.includes(t.tableName))
        .map(t => t.tableDesc)
        .join('、')

      this.$confirm(
        `确定要将 ${this.selectedTables.length} 个表（${selectedTableDescs}）中的URL从 "${this.searchUrl}" 更新为 "${this.newUrl}" 吗？`,
        '确认更新',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).then(() => {
        this.replaceLoading = true
        this.$http.post('/adclickreport/adclickreport/batchUpdateUrl', {
          oldUrl: this.searchUrl,
          newUrl: this.newUrl,
          tableNames: this.selectedTables
        }).then(({ data: res }) => {
          this.replaceLoading = false
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }

          this.$message.success(res.msg || `更新成功，共更新 ${res.data} 条记录`)

          // 重置表单
          this.searchUrl = ''
          this.newUrl = ''
          this.tableList = []
          this.selectedTables = []
          this.totalCount = 0
        }).catch(() => {
          this.replaceLoading = false
        })
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-link-replace {
  padding: 20px;

  .page-title {
    margin-bottom: 20px;
    h2 {
      font-size: 24px;
      color: #303133;
      border-left: 4px solid #409EFF;
      padding-left: 10px;
      margin: 0;
    }
  }

  .step-card {
    margin-bottom: 20px;

    .card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .step-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }

      .total-count {
        color: #409EFF;
        font-weight: 600;
      }
    }

    .selection-info {
      margin-top: 15px;
      text-align: center;
    }
  }
}
</style>
